import { Modal } from "antd"
import { Banner } from "../../Landing/VerConvocatorias/components/Banner/Banner";
import { Information } from "../../Landing/VerConvocatorias/components/Information/Information";


interface IModalVisualizar {
    openModal: boolean;
    setOpenModal: Function;
    convocatoria: any
}

export const ModalVisualizar = ({ openModal, setOpenModal, convocatoria }: IModalVisualizar) => {

    const onCancel = () => setOpenModal(!openModal)

    return (
        <Modal
            visible={openModal}
            onCancel={onCancel}
            width={'100%'}
            footer={null}
        >
            <Banner convocatorias={convocatoria} />
            <Information convocatorias={convocatoria} isVisualizar={true} />
        </Modal>
    )
}
